export enum KnmPmPlanKnmMessageTypesEnum {
  EXCLUDE_CONTROLLING_SUBJECT = 'EXCLUDE_CONTROLLING_SUBJECT',
  EXCLUDE_KNM = 'EXCLUDE_KNM',
}
